/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether the entry came from automatic profile parsing (PARSER) or was added by a Drop owner / admin (USER).
 * @export
 */
export const StorefrontAddedBy = {
    PARSER: 'PARSER',
    USER: 'USER'
} as const;
export type StorefrontAddedBy = typeof StorefrontAddedBy[keyof typeof StorefrontAddedBy];


export function instanceOfStorefrontAddedBy(value: any): boolean {
    for (const key in StorefrontAddedBy) {
        if (Object.prototype.hasOwnProperty.call(StorefrontAddedBy, key)) {
            if (StorefrontAddedBy[key as keyof typeof StorefrontAddedBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StorefrontAddedByFromJSON(json: any): StorefrontAddedBy {
    return StorefrontAddedByFromJSONTyped(json, false);
}

export function StorefrontAddedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorefrontAddedBy {
    return json as StorefrontAddedBy;
}

export function StorefrontAddedByToJSON(value?: StorefrontAddedBy | null): any {
    return value as any;
}

export function StorefrontAddedByToJSONTyped(value: any, ignoreDiscriminator: boolean): StorefrontAddedBy {
    return value as StorefrontAddedBy;
}

